/**
 * components/hazard/DateSection.js — Огноо сонгох хэсэг.
 *
 * Props:
 *   value     : moment object эсвэл undefined
 *   onChange  : (moment|null) => void
 *   showTime  : boolean — цаг сонгох эсэх
 */
import React from "react";
import { DatePicker } from "antd";
import { Card, SectionTitle } from "./common";

export default function DateSection({
  value,
  onChange,
  showTime = false,
  label = "Огноо",
}) {
  return (
    <Card>
      <SectionTitle>{label}</SectionTitle>
      <DatePicker
        value={value}
        onChange={onChange}
        showTime={showTime}
        format={showTime ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD"}
        style={{ width: "100%" }}
      />
    </Card>
  );
}
